import { render } from "./internal.vue?vue&type=template&id=f70afed4"
import script from "./internal.vue?vue&type=script&lang=js"
export * from "./internal.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__